var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, ViewChild, Components, Utils, PropertyConverters, Defaults, Animations, Debounce, avoidHandler } from '@pacem/pacem-core';
//namespace Components.UI {
let PacemTocElement = class PacemTocElement extends Components.PacemElement {
    constructor(_tweener = new Animations.TweenService()) {
        super();
        this._tweener = _tweener;
        this._items = [];
        this._scrollToSelf = (evt) => {
            this._scrollTo('#' + evt.target.id);
        };
        this._hashChange = (evt) => {
            evt.preventDefault();
            this._scrollTo(window.location.hash, false);
        };
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        // url
        switch (name) {
            case 'target':
                if (!Utils.isNull(this._observer))
                    this._observe();
                break;
            case 'selector':
                this.refresh();
                break;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('hashchange', this._hashChange, false);
    }
    disconnectedCallback() {
        window.removeEventListener('hashchange', this._hashChange, false);
        if (!Utils.isNull(this._observer))
            this._observer.disconnect();
        super.disconnectedCallback();
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._observer = new MutationObserver((e) => { this.refresh(); });
        this._observe();
    }
    _onScroll(evt) {
        this._update(Utils.scrollTop);
    }
    _observe() {
        this._observer.observe(this.target || document.body, { subtree: true, childList: true });
    }
    _getTop(dom) {
        return Utils.offset(dom).top;
    }
    _scrollTo(selector, tween = true) {
        if (/^#[^&=]+$/.test(selector)) {
            const dom = !Utils.isNullOrEmpty(selector) && document.querySelector(selector), item = !Utils.isNull(dom) && this._items.find(i => i.dom === dom);
            if (item && !Utils.isNull(item.dom)) {
                const tget = this._getTop(item.dom) - (this.offset || 0);
                if (tween) {
                    let from = Utils.scrollTop;
                    window.location.hash = item.dom.id;
                    this._tweener.run(from, tget, 500, 0, Animations.Easings.sineInOut, (t, v) => {
                        window.scrollTo(0, v);
                    });
                }
                else {
                    window.scrollTo(0, tget);
                }
            }
        }
    }
    _startScrollTo(item, evt) {
        avoidHandler(evt);
        this._scrollTo(item.url);
    }
    _update(top) {
        // pick focused item (fallback: first item)
        const zero = top + (this.offset || 0);
        var current = this._items && this._items.length > 0 && this._items[0];
        for (var item of this._items) {
            if (Utils.offset(item.dom).top <= zero)
                current = item;
            else
                break;
        }
        // update css
        const datasource = [];
        for (var item of this._items) {
            if (Utils.isNullOrEmpty(item.dom.id)) {
                item.dom.id = item.dom.innerText.trim().replace(/[^a-zA-Z0-9]/g, '-').replace(/-*$/, '').replace(/^-*/, '').toLowerCase();
            }
            datasource.push({ focus: item === current, label: item.dom.innerText, url: '#' + item.dom.id });
        }
        if (!Utils.isNull(this._repeater))
            this._repeater.datasource = datasource;
    }
    /** DOM might change while interacting with the page, this method allows extemporary resets. */
    refresh() {
        // reset items
        for (let item of this._items) {
            item.dom.removeEventListener('click', this._scrollToSelf, false);
            Utils.removeClass(item.dom, PCSS + '-toc-item');
        }
        //
        const selector = this.selector;
        if (Utils.isNullOrEmpty(selector)) {
            this._repeater && (this._repeater.datasource = []);
            this.hasContent = false;
            return;
        }
        const items = (this.target || document).querySelectorAll(selector), elements = [];
        for (let j = 0; j < items.length; j++) {
            const dom = items.item(j);
            dom.addEventListener('click', this._scrollToSelf, false);
            Utils.addClass(dom, PCSS + '-toc-item');
            elements.push({ dom: dom, top: this._getTop(dom) });
        }
        // bootstrap TOC
        this._items = elements;
        this._update(Utils.scrollTop);
        this.hasContent = !Utils.isNullOrEmpty(elements);
        // initial state
        let initialTarget = window.location.hash;
        if (!Utils.isNullOrEmpty(initialTarget)) {
            // in case of hash
            setTimeout(() => {
                this._scrollTo(initialTarget, true);
            }, 1000);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTocElement.prototype, "selector", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTocElement.prototype, "offset", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemTocElement.prototype, "target", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Element })
], PacemTocElement.prototype, "router", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemTocElement.prototype, "hasContent", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemTocElement.prototype, "_repeater", void 0);
__decorate([
    Debounce(100)
], PacemTocElement.prototype, "_onScroll", null);
__decorate([
    Debounce(250)
    /** DOM might change while interacting with the page, this method allows extemporary resets. */
], PacemTocElement.prototype, "refresh", null);
PacemTocElement = __decorate([
    CustomElement({
        tagName: P + '-toc', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-scroll-aware on-${Components.ScrollEventName}=":host._onScroll($event)" url="{{ :host.url }}"></${P}-scroll-aware>
<${P}-repeater><nav class="${PCSS}-toc"><template>
    <${P}-a on-click=":host._startScrollTo(^item, $event)" router="{{ :host.router }}" css-class="{{ {'toc-focus': ^item.focus} }}" href="{{ ^item.url }}"><${P}-text text="{{ ^item.label }}"></${P}-text></${P}-a>
</template></nav></${P}-repeater>`
    })
], PacemTocElement);
export { PacemTocElement };
